import request from "@/utils/request";

let PointsApi = {
    /*拼团活动列表*/
    activeList(data, errorback) {
        return request._post("/merch/activity.point/index", data, errorback);
    },
    getGoods(data, errorback) {
        return request._get("/merch/activity.point/add", data, errorback);
    },
    addGoods(data, errorback) {
        return request._post("/merch/activity.point/add", data, errorback);
    },
    /*我的活动列表*/
    myList(data, errorback) {
        return request._post("/merch/activity.point/my", data, errorback);
    },
    /*根据主键查询*/
    detailGoods(data, errorback) {
        return request._get("/merch/activity.point/edit", data, errorback);
    },
    /*根据主键查询*/
    saveGoods(data, errorback) {
        return request._post("/merch/activity.point/edit", data, errorback);
    },
    delGoods(data, errorback) {
        return request._post("/merch/activity.point/del", data, errorback);
    }
};
export default PointsApi;



// WEBPACK FOOTER //
// ./src/api/points.js